import { useMemo } from "react";

import { SchemaForFormData, UiSchemaForFormData } from "@nens/shared-utils";

import { useMunicipalitiesQuery } from "@/queries/query-municipality";

import { MainFormData } from "../types/main-form-data";

export const useMainForm = () => {
  const { data: municipalities, isLoading } = useMunicipalitiesQuery();

  return useMemo(() => {
    if (isLoading) return { isLoading, schema: null, uiSchema: null };

    const schema: SchemaForFormData<MainFormData> = {
      title: "Project gegevens",
      type: "object",
      required: ["name", "gemeente"],
      properties: {
        name: {
          type: "string",
          title: "Projectnaam",
        },
        project_nummer: {
          type: "string",
          title: "Projectnummer",
        },
        gebied: {
          type: "string",
          title: "Gebiedsnaam",
        },
        gemeente: {
          type: "string",
          title: "Gemeente",
          enum: municipalities?.map(({ gemeentenaam }) => gemeentenaam) || [],
        },
      },
    };

    const uiSchema: UiSchemaForFormData<MainFormData> = {
      name: {
        "ui:placeholder": "Voer projectnaam in",
      },
      project_nummer: {
        "ui:placeholder": "Voer projectnummer in",
      },
      gebied: {
        "ui:placeholder": "Voer gebied in",
      },
      gemeente: {
        "ui:placeholder": "Kies gemeente",
      },
    };
    return { isLoading, schema, uiSchema };
  }, [isLoading, municipalities]);
};
